import React, { type FC } from "react";
import Text from "../atoms/Text";
import styles from "./GradeSwitcher.module.scss";
import skeleton from "../utils/Skeleton.module.scss";
import Button from "../atoms/Button";

const GradeSwitcherSkeleton: FC = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <Text variant="apheleia-h3" tag="h2" skeleton className={styles.headerskeleton} />
            </div>
            <div className={styles.filters}>{/*<Filter />*/}</div>
            <div className={styles.scroll}>
                <div className={styles.grid}>
                    {Array.from({ length: 10 }, (_, index) => (
                        <div className={styles.item} key={index}>
                            <article className={styles["item-skeleton-wrapper"]}>
                                <div>
                                    <header>
                                        <div>
                                            <div className={styles.title}>
                                                <Text tag="div" variant="apheleia-h4" skeleton spacing="spacing-2" />
                                            </div>
                                            <Text tag="div" variant="apheleia-body-large" skeleton />
                                        </div>
                                    </header>
                                    <div>
                                        <figure className={skeleton.skeletonimg} />
                                    </div>
                                    <div>
                                        <Text tag="div" variant="apheleia-body" skeleton spacing="spacing-2" />
                                        <Text tag="div" variant="apheleia-body" skeleton spacing="spacing-2" />
                                        <Text tag="div" variant="apheleia-body" skeleton spacing="spacing-2" />
                                        <Text tag="div" variant="apheleia-body" skeleton />
                                    </div>
                                </div>
                                <footer className={styles["item-skeleton-footer"]}>
                                    <Button
                                        disabled
                                        variant="btn-default"
                                        sizing="pill"
                                        className={styles.button}
                                        skeleton
                                    />
                                </footer>
                            </article>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default GradeSwitcherSkeleton;
